<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <footer class="app-footer">
    <div class="footer-content">
      <!-- Custom left slot -->
      <slot name="left">
        <span class="copyright">
          &copy; {{ currentYear }} {{ copyrightHolder }} -
          <a :href="copyrightUrl" target="_blank" rel="noopener">{{
            copyrightLink
          }}</a>
        </span>
      </slot>

      <!-- Custom center slot -->
      <slot name="center"></slot>

      <!-- Custom right slot -->
      <slot name="right">
        <span v-if="showVersion" class="version" v-tooltip.top="versionTooltip">
          v{{ version }}
        </span>
      </slot>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  props: {
    /**
     * Copyright holder name
     */
    copyrightHolder: {
      type: String,
      default: "JECI SARL",
    },
    /**
     * Copyright link text
     */
    copyrightLink: {
      type: String,
      default: "Pristy",
    },
    /**
     * Copyright link URL
     */
    copyrightUrl: {
      type: String,
      default: "https://pristy.fr",
    },
    /**
     * Show version number
     */
    showVersion: {
      type: Boolean,
      default: true,
    },
    /**
     * Version string (defaults to build version if available)
     */
    version: {
      type: String,
      default: () => {
        if (typeof __BUILD_VERSION__ !== "undefined") {
          return __BUILD_VERSION__;
        }
        return "0.0.0";
      },
    },
    /**
     * Git commit hash for tooltip
     */
    commit: {
      type: String,
      default: () => {
        if (typeof __BUILD_COMMIT__ !== "undefined") {
          return __BUILD_COMMIT__;
        }
        return "unknown";
      },
    },
    /**
     * Build date for tooltip
     */
    buildDate: {
      type: String,
      default: () => {
        if (typeof __BUILD_DATE__ !== "undefined") {
          return __BUILD_DATE__;
        }
        return "unknown";
      },
    },
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    versionTooltip() {
      return `Commit: ${this.commit}\nBuild: ${this.buildDate}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-footer {
  background: var(--p-content-background);
  border-top: 1px solid var(--p-content-border-color);
  padding: 1rem;
  transition: background-color 0.3s ease;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  font-size: 0.875rem;
  color: var(--p-text-muted-color);
}

.copyright a {
  color: var(--p-primary-color);
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.version {
  cursor: help;
}
</style>
